import { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import { FormGroup, Input, Label } from 'reactstrap';
import DefaultButton from '../../../../../components/Buttons/Default';
import { useTranslation } from 'react-i18next';

const EMPTY_FILTERS = {
  min_amount: '',
  max_amount: '',
  status: '',
  added_after: '',
  added_before: ''
}

function FiltersDrawer({isOpen, toggle, applyFilters, filters = {}}) {
  const { t } = useTranslation();
  const [filtersData, setFiltersData] = useState({...EMPTY_FILTERS, ...filters});

  useEffect(() => {
    if (isOpen) {
      setFiltersData({...EMPTY_FILTERS, ...filters});
    }
  }, [isOpen]);

  const clearFilters = () => {
    setFiltersData(EMPTY_FILTERS);
    applyFilters({});
  };

  return(
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction="right"
      size={400}
      enableOverlay={true}
      zIndex={9000}
      duration={200}
    >
      <div className="p-3 drawer-content">
        <h4 className="fw-bold">{t('common.filter')}</h4>

        <FormGroup>
          <Label>{t('common.minAmount')}</Label>
          <Input
            type="number"
            value={filtersData.min_amount}
            onChange={(e) => setFiltersData({...filtersData, min_amount: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.maxAmount')}</Label>
          <Input
            type="number"
            value={filtersData.max_amount}
            onChange={(e) => setFiltersData({...filtersData, max_amount: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.status')}: </Label>
          <Input
            type="select"
            value={filtersData.status}
            onChange={(e) => setFiltersData({...filtersData, status: e.target.value})}
          >
            <option value="">{t('common.selectStatus')}</option>
            <option value="draft">{t('common.draft')}</option>
            <option value="sent">{t('common.sent')}</option>
            <option value="paid">{t('common.paid')}</option>
            <option value="partially_paid">{t('common.partiallyPaid')}</option>
            <option value="overdue">{t('common.overdue')}</option>
          </Input>
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedAfter')}</Label>
          <Input
            type="date"
            value={filtersData.added_after}
            onChange={(e) => setFiltersData({...filtersData, added_after: e.target.value})}
          />
        </FormGroup>
        <FormGroup>
          <Label>{t('common.addedBefore')}</Label>
          <Input
            type="date"
            value={filtersData.added_before}
            onChange={(e) => setFiltersData({...filtersData, added_before: e.target.value})}
          />
        </FormGroup>

        <DefaultButton block onClick={() => applyFilters(filtersData)} style={{marginBottom: '10px'}}>
          {t('common.filter')}
        </DefaultButton>

        <DefaultButton block onClick={clearFilters} color="light" outline>
          {t('common.cancel')}
        </DefaultButton>
      </div>
    </Drawer>
  );
}

export default FiltersDrawer;